<template>
	<div class="my-admin">
		<!-- 派单时选择业务员信息 -->
		<common-modal :showClose="true" v-if="isDispatch"  @close-modal="onCloseModalClick">
		    <div class="modal">
		        <div class="title">设置处理人员信息</div>
				<div class="sale-wrap">
					<p class="name-title">业务员</p>
					<select v-model="saleSelect" @blur="backHeight">
						<option v-for="(item,index) in salesMan" :key="index" :value="item.uuid">{{item.user_name}}</option>
					</select>
					<p class="name-title">佣金比例</p>
					<div class="commission-wrap">
						<input placeholder="请输入佣金比例" type="tel" v-model="money" @blur="backHeight"/>
						<span>%</span>
					</div>
				</div>
				<div class="submit-sale" @click="submitDispatch">提交</div>
		    </div>
		</common-modal>
		
		<!-- 退款 -->
		<common-modal :showClose="true" v-if="isRefund"  @close-modal="onCloseModalClick">	
		    <div class="modal">
		        <div class="title">退款</div>
				<div class="sale-wrap">
					<p class="name-title">退款金额</p>
					<div class="commission-wrap com-mb">
						<input placeholder="请输入退款金额" type="tel" v-model="refundMoney" @blur="backHeight"/>
					</div>
				</div>
					
				<div class="submit-sale" @click="submitRefund">提交</div>
		    </div>
		</common-modal>
		
		<!-- 是否设置截止时间弹框 -->
		<common-modal :showClose="true" v-if="isShowTime"  @close-modal="onCloseModalClick">
		    <div class="modal">
		        <div class="title">是否设置截止时间</div>
		        <div class="time-common set-time" @click="showDatePicker">设置截止时间</div>
		        <div class="time-common no-time"  @click="noSetHandle">无需设置</div>
		    </div>
		</common-modal>
		
		<!-- 撤单成功弹框，开始处理弹框 -->
		<confirm-modal v-if="isSetTime" :noWidth="true" :isEnough="true" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
		    @leftClick="goBackList" @rightClick="lookOrder">
		</confirm-modal>
		
		<!-- 是否处理成功弹框 -->
		<confirm-modal v-if="isSuccess" :isEnough="true" :firmTitle="firmTitle_1" :firmLeft="firmLeft_one" :firmRight="firmRight_one"
		    @leftClick="onCloseModalClick" @rightClick="submitSuccess">
		</confirm-modal>
		
		<!-- 是否完成订单弹框-->
		<confirm-modal v-if="isComplete" :isEnough="true" :firmTitle="firmTitle_1" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
		    @leftClick="onCloseModalClick" @rightClick="submitComplete">
		</confirm-modal>
		
		<!-- 是否撤回订单,确认退款，已驳回状态下的撤单弹框-->
		<confirm-modal v-if="isRevoke" :firmTitle="firmTitle_2" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
		    @leftClick="onCloseModalClick" @rightClick="submitRevoke">
		</confirm-modal>
		
		<!-- 拒绝驳回 -->
		<refusal-modal v-if="isRefusal" @close-modal="onCloseModalClick"  @submit-refusal="submitRefusal"></refusal-modal>
		
		<!-- 撤单原因弹框 -->
		<common-modal :showClose="true" v-if="isRescind" @close-modal="onCloseModalClick">
			<div class="modal ">
			    <div class="title">{{rescindTitle}}</div>
			    <ul class="list-wrap che-dan">
		            <li v-if="rescindFlag">
                        <div v-for="(item,index) in rescindList" :key="index" class="com-mb">
                            <span class="select-mark" @click="selectFlag=index" :class='selectFlag==index?"done":"undone"'></span>
                            <span class="modal-text">{{item}}</span>
                        </div>
		            </li>
		            
		            <li v-if="selectFlag==3">
		            	<textarea class="textarea" :rows="8" v-model="otherReason" @blur="backHeight" placeholder="请详细描述撤单原因，便于管理员找商家谈条件，好提高成功率"/>
		            </li>
		            
		            <li class="admin-img">
		            	<div class="num">上传图片（{{addImages.length }}/6）</div>
		            	<imageUpload v-model="addImages" :limit="6" class="add-img"/>
		            </li>
			    </ul>
			    <div class="modal-submit" @click="submitRescind">提交</div>
			</div>
		</common-modal>
		
		<div :style="{ height: wrapperHeight + 'px' }" class="list">
			<!-- 搜索栏 -->
			<div class="fixed-wrap">
				<div class="search-wrap">
					<form action="#" onsubmit="return false" class="search-content">
					  <input id="searchInput" ref="input1" type="search" v-model.trim="keyword" @keyup.13='search' placeholder="请输入订单编号/买家旺旺/卖家旺旺查找">
					</form> 
				</div>
				
				<div class="tabs myorder-tab">
					<p class="tab-btn" v-for="(item,index) in tabs" :key='index' :class='tabCur==item.status?"btn-active":""' @click="changeTabs(item)">
						<span>{{item.name}}</span>
						<span v-if="item.status==2 && isShowUnRead" class="unpay-num"></span>
					</p>
				</div>
			</div>
			
			<mt-loadmore v-if="orderList && orderList.length" :bottom-method="loadBottom" :auto-fill="false" :bottom-all-loaded="allLoaded" ref="loadmore" :bottomPullText='"加载更多"' :bottomLoadingText='"加载中"' :bottomDropText='"释放加载"'>
				<div class="page-con">
					<div class="c_item" v-for="(item,index) in orderList" :key="index" @click="goToDetail(item)">
						<div class="i_part1">
							<div class="c_item_img">
								<img :src="imgUrl+item.server_info.server_icon" alt="">
								<p class="title-c">{{item.server_info.server_name}}</p>
								<p class="status-c" :class='item.order_status==1 || item.order_status==10 || item.order_status==11?"co-status":""'>{{item.statusName}}</p>
							</div>
							
							<div class="c_item_info">
								<img src="@/assets/images/order-manage/ic_order_2.png" alt="">
								<span class="order-num">{{item.order_code}}</span>
								<div class="copy" @click.stop="utils.copyText(item.order_code)">复制</div>
								<img src="@/assets/images/order-manage/ic_order_1.png" alt="" class="wang-wang">
								<!-- <span v-if='item.server_type==1' class="name">{{item.merchant_wangwang}}</span> -->
								<p class="name sale" v-text='item.salesman_name?item.salesman_name:"暂无处理人员"'></p>
							</div>
							
							<div class="c_item_info mp-b">
								<img src="@/assets/images/order-manage/ic_order_time.png" alt="">
								<span class="order-num">{{item.create_time}}</span>
							</div>
							
						</div>
						
						<div class="i_part2">
							<p class="p_count">合计：<span class="i_money">¥{{item.order_total_price}}</span></p>
							
							<!--1待支付 2待处理 3 处理中 4待确认 5已完成 6 已撤单 7 取消订单 8 已驳回 9已退款 10退款中 11未解决 -->
							
							<p class="p_btns" v-if="item.order_status==2">
								<!-- 2待处理，未派业务员 已指派业务员-->
								<span class="acDo_btn_2" v-if="!item.salesman_uuid" @click.stop="dispatch(index)">派单</span> 
								<span class="acDo_btn_3" v-if="item.salesman_uuid"  @click.stop="rescind(index,2)">撤回</span>
								<span class="acDo_btn_3" v-if="item.salesman_uuid"  @click.stop="follow(index)">进度</span>
							</p>   
								
							<!-- 3 处理中 -->
							<p class="p_btns" v-if="item.order_status==3">
								<span class="acDo_btn_3"  @click.stop="rescind(index,2)">撤回</span>
								<span class="acDo_btn_3"  @click.stop="handleSuccess(index)">成功</span>
								<span class="acDo_btn_1"  @click.stop="follow(index)">进度</span>
							</p>
								
							<!-- 4 待确认 -->
							<p class="p_btns" v-if="item.order_status==4">	
								<span class="acDo_btn_3"  @click.stop="rescind(index,2)">撤回</span> 
								<span class="acDo_btn_3"  @click.stop="follow(index)">进度</span>
							</p>
                            
                            <!-- 5 已完成 -->
                            <p class="p_btns" v-if="item.order_status==5">	
                            	<span class="acDo_btn_3"  @click.stop="follow(index)">进度</span>
                            </p>
							
							<!-- 6 已撤单 -->
							<p class="p_btns" v-if="item.order_status==6 || item.order_status==13">	
								<span class="acDo_btn_1"  @click.stop="dispatch(index)">派单</span>
								<!-- <span class="acDo_btn_2"  @click.stop="revoke(index,9)">撤单</span> -->
                                <span class="acDo_btn_2"  @click.stop="rescind(index,1)">撤单</span>
								<span class="acDo_btn_1"  @click.stop="follow(index)">进度</span>
							</p>

							<!-- 8 已驳回 -->
							<p class="p_btns" v-if="item.order_status==8">	
								<span class="acDo_btn_1"  @click.stop="rescind(index,1)">撤单</span>
								<span class="acDo_btn_2"  @click.stop="dispatch(index)">派单</span>
								<span class="acDo_btn_1"  @click.stop="follow(index)">进度</span>
							</p>
							
							<!-- 11 未解决 -->
							<p class="p_btns" v-if="item.order_status==11">	
								<span class="acDo_btn_1"  @click.stop="dispatch(index)">派单</span>
								<span class="acDo_btn_3 "  @click.stop="revoke(index,3)">即退</span>
								<span class="acDo_btn_1"  @click.stop="follow(index)">进度</span>
							</p>	
							
							<!-- 10 退款中 -->
							<p class="p_btns" v-if="item.order_status==10">	
								<!-- <span class="acDo_btn_1"  @click.stop="revoke(index,11)">拒绝</span> -->
								<span class="acDo_btn_2"  @click.stop="revoke(index,3)">同意</span>
								<span class="acDo_btn_1"  @click.stop="refund(index)">退款</span>
								<span class="acDo_btn_3"  @click.stop="follow(index)">进度</span>
							</p>
							
							<!-- 9 已退款 -->
							<p class="p_btns" v-if="item.order_status==9">	
								<span class="acDo_btn_3"  @click.stop="refund(index)">退款</span>
								<span class="acDo_btn_3"  @click.stop="follow(index)">进度</span>
							</p>
						</div>
					</div>
				</div>
			</mt-loadmore>	
			<div v-else>
				<div class="no-order">
					<img src="../../assets/images/no-order.png">
                    <p>暂无订单</p>
				</div>
			</div>
		</div>
		<!-- <div class="add-order" @click="addOrder">新建订单</div> -->
	</div>
</template>
<script>
import imageUpload from '@/components/ImageUpload';
import utils from '@/assets/jslibs/utils'
import {getAdminOrder,adminOrder,processingOrder,getSalesman} from '@/api/order'
import RefusalModal from '@/components/RefusalModal'
import ConfirmModal from '@/components/ConfirmModal'
import CommonHeader from '@/components/CommonHeader'
import CommonModal from '@/components/CommonModal'

export default {
    name : 'myOrder',
    data(){
        return {
			utils,
			wrapperHeight:0,
			allLoaded:false,
			imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
			isDispatch:false,
			orderPrice:null,		//当前订单的金额
			saleSelect:"",		   //派单时选中的业务员
			money:"",       		 //佣金比例百分比
			isRescind:false,         //撤单原因弹框
			selectFlag:0,       	//选择撤单原因
			otherReason:"",      	//撤单理由
			addImages:[],          //上传的图片
            rejectImg:[],          //拒绝驳回图片
			isSetTime:false,
			firmTitle:"截止时间设置成功",
			firmLeft:"返回列表",
			firmRight:"查看订单",

			isSuccess:false,  		          //是否处理成功弹框
			firmTitle_1:"订单解决了吗？",
			firmLeft_one:"否",
			firmRight_one:"是",
			firmLeft_1:"取消",
			firmRight_1:"确定",
			isComplete:false,       //是否完成功能订单弹框
			isRevoke:false,         //是否撤回订单，以及驳回状态下的是否撤单
			firmTitle_2:"",
			
			isRefund:false,       //是否退款
            refundMoney:"",       //退款金额        
            deadline:"",            //截止时间
            order_uuid:"",         //当前操作订单的id
            isShowTime:false,      //是否设置时间弹框
            isSubmit:false,        //确认完成弹窗
			isRefusal:false,       //拒绝驳回
			reason:"",  		//拒绝驳回理由
			
			salesMan:[],
			tabCur:1,
			tabs:[{name:"全部",status:1},{"name":"处理中",status:6},{"name":"待处理",status:2},{"name":"未解决",status:4},{"name":"已成功",status:3}],
            rescindList:["客户不愿意协商","无法联系客户","商家要求撤单","其它原因"],
            reasons_for_cancellation:"",   //撤单理由
            orderList:[],
            page_index: 1,
            page_size: 25,
			keyword:"",
			searchTimer:null,	//搜索截流
			num:null,			//判断是撤回订单还是,驳回状态下的撤单
			isShowUnRead:false,
			isMobile : utils.isMobile(),
            rescindFlag:true,
            rescindTitle:"请选择撤单原因"
        }
    },
	
	beforeCreate(){
		sessionStorage.removeItem("roleType");
	},
    
    created(){
       this.getAdminOrder("1")
	   this.getSalesman()
    },
	
	mounted(){
	    this.wrapperHeight = document.documentElement.clientHeight;
        document.title = "服务平台";
		window.addEventListener('touchmove', (event)=>{ 
		    if(this.isDispatch || this.isShowTime || this.isSetTime || this.isSuccess ||
			 this.isComplete || this.isRevoke || this.isRefusal || this.isRescind || this.isRefund){
		        event.preventDefault(); 
		    }
		}) 
	},
    
    methods:{
		// 管理员订单列表
        async getAdminOrder(type){
			if(this.isMobile==2){//pc端展示所有的
				this.page_size = 999;
			}
            let obj={status:type,keyword_search:this.keyword,page_index:this.page_index,page_size:this.page_size};
            const { data, status } = await getAdminOrder(obj);
            if (status !== 200) return 
            this.orderList = data.data;
			if(data.data.length){
			    this.page_index += 1;
			}
			this.orderList.forEach((item,index)=>{
				item.statusName = utils.statusToName(item.order_status)
				if(item.statusName=="已撤单"){
				    item.statusName = "已撤回"
				}
				if(item.order_status == "2"){//如果有待处理订单,则显示未读标记
					this.isShowUnRead = true
				}
			})
        },
		
		loadBottom(){
		    this.$refs.loadmore.onBottomLoaded();
		    this.$refs.loadmore.onTopLoaded();
		    this.loadMore()
		},
		
		async loadMore(){
			let obj={status:this.tabCur,keyword_search:this.keyword,page_index:this.page_index,page_size:this.page_size};
		    const { data, status } = await getAdminOrder(obj);
		    if( status !== 200) return
		    if(data.data.length){
		        this.page_index += 1
		        this.orderList = this.orderList.concat(data.data);
				this.orderList.forEach((item,index)=>{
					item.statusName = utils.statusToName(item.order_status)
					if(item.statusName=="已撤单"){
					    item.statusName = "已撤回"
					}
					if(item.order_status == "2"){//如果有待处理订单,则显示未读标记
						this.isShowUnRead = true
					}
				})
		    }else{
		        window.toast("没有更多数据","txt");
		    }
		},
		
		//跟进订单记录
		follow(index){
			this.count = index;
			this.$router.push({path:'./order-speed',query:{order_uuid:this.orderList[index].uuid,follow:"admin"}})
		},
		
		// 派单
		dispatch(index){
			this.isDispatch =true
			this.order_uuid = this.orderList[index].uuid;
            this.money = Number( this.orderList[index].commission_rate)*100;   //默认显示当前订单佣金比例,前端展示
		},
		
		// 撤单(已驳回状态下的撤单)
		rescind(index,num){
			this.isRescind = true
			this.order_uuid = this.orderList[index].uuid;
            if(num == 2){//撤回,此时只需要撤单理由输入框和上传图片
                this.rescindFlag = false;
                this.selectFlag = 3;
                this.rescindTitle = "请选择撤回原因"
            }else{
                this.rescindFlag = true;
                this.selectFlag = 0;
                this.rescindTitle = "请选择撤单原因"
            }
		},
		
		// 处理成功
		handleSuccess(index){
			this.isSuccess = true    
			this.order_uuid = this.orderList[index].uuid;
		},
		
		//完成订单
		// complete(index){
		// 	this.isComplete = true    
		// 	this.firmTitle_1="是否处理完成当前订单",
		// 	this.order_uuid = this.orderList[index].uuid;
		// },
		
		// 撤回订单，拒绝退款，同意退款，回状态下的撤单
		revoke(index,num){
			this.num = num
			this.isRevoke= true;
			this.order_uuid = this.orderList[index].uuid;
			if(num=="3"){//立即退款，同意退款
				this.firmTitle_2 = "是否立即退款"
			}
// 			else if(num=="4"){
// 				this.firmTitle_2 = "是否撤回该订单"
// 			}
// 			else if(num=="9"){//已撤单状态下的撤单
// 				this.firmTitle_2 = "是否撤销该订单"
// 			}
			else if(num=="11"){//拒绝退款
				this.firmTitle_2 = "是否拒绝退款"
			}
		},
		
		// 退款
		refund(index){
			this.count = index;
			let backurl = location.href;
			this.$router.push({path:'./refund-detail',query:{order_uuid:this.orderList[index].uuid,refund:"admin",backurl:backurl}})
		},
		
		// 拒绝驳回
		refusalReject(index){
			this.isRefusal = true
			this.order_uuid = this.orderList[index].uuid;
		},
		
		// 设置处理的截止时间
		showDatePicker() {
		    this.isShowTime = false;
		    if (!this.datePicker) {
		        this.datePicker = this.$createDatePicker({
		            title: '设置截止时间',
		            min: new Date(2008, 7, 8),
		            max: new Date(2020, 9, 20),
		            value: new Date(),
		            onSelect: this.selectHandle,
		            onCancel: this.cancelHandle
		        })
		    }
		    
		    this.datePicker.show()
		},
		
		//确定选择时间，并开始处理
		selectHandle(date, selectedVal, selectedText) {
		    this.deadline = selectedVal[0]+"-"+selectedVal[1]+"-"+selectedVal[2];
		    this.processingOrder();     //开始处理
		},
		
		//无需设置截止时间，直接开始处理
		noSetHandle(){
		    this.isShowTime = false;
			this.firmTitle = "订单开始处理中" 	//直接处理成功提示语不一样
		    this.processingOrder();
		},
		
		// 确认派单
		submitDispatch(){
			if(!(/^[1-9]\d*(,\d{3})*(\.\d{1,2})?$/).test(this.money)){
			    window.toast("佣金比例有误","txt");
			    return
			}
			if(this.money>100 || this.money<1){
				window.toast("佣金比例应在1-100之间","txt");
				return
			}
			this.isDispatch = false
			this.adminOrder("1");
		},
		
		// 确定撤单
		submitRescind(){
            if(this.rescindFlag){//撤单校验，撤回时没有选择撤单原因模块
                if(this.selectFlag<0 || this.selectFlag>4){
                	window.toast("请选择撤单原因","txt");
                	return
                }
            }
			if(this.selectFlag==3){//撤单原因为其它，则需要输入原因
				if(!this.otherReason){
                    let tips= ""
                    if(!this.rescindFlag){
                        tips= "请输入撤回原因"
                    }else{
                        tips= "请输入撤单原因"
                    }
					window.toast(tips,"txt");
					return
				}
			    
			    if(this.otherReason.length>100){
                    let tips= ""
                    if(!this.rescindFlag){
                        tips= "撤回"
                    }else{
                        tips= "撤单"
                    }
			    	window.toast(tips+"原因不得超过100字符","txt");
			    	return
			    }
				this.reasons_for_cancellation = this.otherReason;
			}else{
				this.reasons_for_cancellation = this.rescindList[this.selectFlag];
                this.otherReason="";
			}
			this.isRescind = false
            if(!this.rescindFlag){
                this.adminOrder("13");
            }
            else{
                this.adminOrder("6");
            }
			
		},
		
		//确认处理成功订单
		submitSuccess(){
			this.isSuccess = false
			this.adminOrder("2");          //确认处理成功订单
		},
		
		//确认完成订单
		submitComplete(){
			this.isComplete = false
			this.adminOrder("5");
		},
		// 确认退款
		// submitRefund(){
		// 	if(!(/^[1-9]\d*(,\d{3})*(\.\d{2})?$/).test(this.refundMoney)){
		// 	    window.toast("退款金额有误","txt");
		// 	    return;
		// 	}
		// 	if(this.refundMoney<1){
		// 		window.toast("退款金额不得小于1元","txt");
		// 		return;
		// 	}
		// 	
		// 	if(this.refundMoney>this.orderPrice){
		// 		window.toast("退款金额不得大于订单支付金额","txt");
		// 		return;
		// 	}
		// 	this.isRefund = false
		// 	this.adminOrder("3");
		// },
		
		// 确认拒绝驳回
		submitRefusal(reason,rejectImg){
            this.rejectImg = rejectImg;
			this.reason = reason;
			this.isRefusal = false
			this.adminOrder("7");
		},
		
		// 开始处理
		async processingOrder(){
		    let obj={type:"1",deadline:this.deadline};
		    const { data, status } = await processingOrder(this.order_uuid,obj);
		    if (status !== 200) return
			this.isSetTime = true;
            
		},
		
		// 确认撤回订单，退款，驳回下的撤单
		submitRevoke(){
			this.isRevoke = false;
            if(this.num == "3"){//立即退款
				this.adminOrder("3");
			}
			else if(this.num == "11"){//拒绝退款
				this.adminOrder("11");
			}
		},
		
		//操作订单
		async adminOrder(type){
			let obj = {}
			if(type=="1"){//派单
                let commission_rate = Number(this.money)/100;
				obj={type:type,salesman_uuid:this.saleSelect,commission_rate:commission_rate};
			}
			else if(type=="6" || type=="13"){
				obj={type:type,reasons_for_cancellation:this.reasons_for_cancellation,img:this.addImages};
			}
			else if(type=="2" || type=="3" || type=="4" || type=="5" || type=="9" || type=="11"){//完成订单，处理成功订单,关闭
				obj={type:type};
			}
			else if(type=="7"){//拒绝驳回
				obj={type:type,reason_for_rejection:this.reason,img:this.rejectImg};
			}

			const { data, status } = await adminOrder(this.order_uuid,obj);
			if (status !== 200) return
			if(type=="1"){//派单
				this.isDispatch = false;
				this.$router.push({path:'./operate-success',query:{order_uuid:this.order_uuid,flag:"dispatch"}})
			}else if(type=="6" || type=="13"){
				this.isRescind = false;
                if(!this.rescindFlag){
                    this.firmTitle = "撤回成功";
                }else{
                    this.firmTitle = "撤单成功";
                }
				this.isSetTime = true;
                this.otherReason = "",
                this.selectFlag = 0;
                this.addImages = []
			}else if(type=="2" || type=="5" || type=="4" || type=="9" || type=="11"){//处理成功,完成订单，
				this.page_index = 1;
				this.getAdminOrder(this.tabCur)	
			}else if(type=="3"){
				this.$router.push({path:'./operate-success',query:{order_uuid:this.order_uuid,flag:"refund"}})
			}else if(type=="7"){
				this.$router.push({path:'./operate-success',query:{order_uuid:this.order_uuid,flag:"refusalReject"}})
			}
			
		},
		
        // 返回列表,并重新获取状态,当前页面下直接关闭弹框
        goBackList(){
            this.isSetTime = false;
			this.page_index = 1;
            this.getAdminOrder(this.tabCur)
        },
        
        // 查看订单
        lookOrder(){
			this.isSetTime = false;
            this.$router.push({path:'./orderdetail-admin',query:{order_uuid:this.order_uuid}})
        },
 
        // 取消或者关闭弹框
        onCloseModalClick(){
			this.isShowTime = false;
			this.isDispatch = false;
			this.isRescind = false;
			this.isSuccess = false;
			this.isComplete =false;
			this.isRevoke = false;
			this.isRefusal = false;
            this.otherReason = "",
            this.selectFlag = 0;
            this.addImages = []
        },
        
		changeTabs(item){
			this.orderList =[];
			this.tabCur = item.status;
			this.page_index = 1;
			this.getAdminOrder(this.tabCur)
		},
        
		// 查看订单详情
		goToDetail(item){
			this.$router.push({path:'./orderdetail-admin',query:{order_uuid:item.uuid}})
		},
		
		addOrder(){
			this.$router.push({path:'./place-order',query:{isAdmin:"admin"}})
		},
		
		//获取所有业务员
		async getSalesman(){
			let obj={page_index:"1",page_size:"999"}
			const { data, status } = await getSalesman(obj);
			if (status !== 200) return  
			this.salesMan = data.data;
			this.saleSelect = this.salesMan[0].uuid;     //下拉框默认选中第一个
		},
        
        backHeight(){
            setTimeout(() => {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            }, 100);
        },
		
		clearTimer() {
			if (this.searchTimer) {
			  clearTimeout(this.searchTimer);
			}
		},
		
		search(){
			this.$refs.input1.blur();
			this.getAdminOrder(1);
		}
    },
	
	watch:{
		keyword(){
			this.clearTimer();
	        this.searchTimer = setTimeout(()=>{
	            this.page_index =1;
	            this.getAdminOrder("1")
	        },500)
		}
	},
    
    components : {
		imageUpload,
		RefusalModal,
		CommonHeader,
		ConfirmModal,
		CommonModal
    }
}
</script>
<style>
	.list-wrap .admin-img .dankal-image-upload p{margin-left:0;margin-right: 18px;width: 80px;height: 80px;}
	.list-wrap .admin-img .dankal-image-upload p:nth-child(3n){margin-right: 0;}
	.che-dan .dankal-image-upload .add-box{width: 80px;height: 80px;padding-left: 0;padding-bottom: 0;margin-bottom: 0.453333rem;}
	.che-dan .dankal-image-upload .add-box .add{width: 80px;height: 80px;}
	.my-admin .modal-wrap{position: absolute;top: 0;left: 0;width: 100vw;height: 100vh;z-index: 12;}
</style>
<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	.no-order{width:56px;height:82.5px;margin: 0 auto;margin-top:50%;margin-bottom:50%}
	.no-order img{width: 100%;height: 100%}
    .no-order p{text-align: center;font-size:13px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(207,207,207,1);line-height:18.5px;margin-top: 10.5px}
	.list{overflow-y: scroll; width: 100%;height: 100%;-webkit-overflow-scrolling: touch;background: #f5f5f5;}
    body{width:100%;height:100%;background:#F5F5F5;font-family:PingFangSC-Regular;font-weight:400;}
    .tabs{width:100%;.h(44);display:flex;background:#fff;z-index: 9}
    .tab-btn{flex:1;.l-h(44);text-align:center; .f-s(14);font-family:PingFangSC-Medium;font-weight:500;position: relative;}
    .tab-btn span{display:inline-block;.h(43);.l-h(43);}
	.tab-btn .unpay-num{display: inline-table;position: absolute;width: 7px;height: 7px;border: none;background: rgba(255,134,48,1);border-radius: 50%;top: 26%;right: 10%;}
    .btn-active span{color:#4184F4;border-bottom:1px solid #4184F4;}
    .page-con{padding:0.3rem; background:#f5f5f5;}
	.c_item{padding:10px 10px 0 10px;  background:#fff;margin-bottom:10px;}
	.i_part1{border-bottom:1px solid #f5f5f5;}
	.i_part1 .c_item_img{display:flex;align-items: center;}
	.i_part1 .c_item_img img{height: 21px;width: 21px;margin-right: 9px;}
	.i_part1 .c_item_img .title-c{font-weight: 500;color: rgba(51,51,51,1);font-size: 15px;}
	.i_part1 .c_item_img .status-c{font-weight: 500;color: rgba(65,132,244,1);font-size: 13px;width: 1.6rem; text-align: right;flex: 1;}
	.i_part1 .c_item_img .co-status{color:rgba(255,134,48,1);}
	.i_part1 .c_item_info{display: flex;align-items: center;padding-top: 15px;}
	.i_part1 .mp-b{margin-top: 6px;margin-bottom: 8px;padding-top: 0px;}
	
	
	.c_item_info img{width: 15px;height: 15px;}
	.c_item_info .order-num{font-size: 14px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);margin: 0 5px 0 9px;}
	.c_item_info .copy{font-size: 12px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);padding: 1px 5px;border-radius: 1px; border: 1px solid rgba(193,193,193,1);}
	.c_item_info .wang-wang{margin: 0 4px 0 32px}
	.c_item_info .name{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 120px;font-size: 14px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);}
	.c_item_info .sale{margin-left: 0.2rem;}

    .i_part1 .c_item_state{.w(60);line-height:0.6rem; text-align:right; .f-s(13); color:#333;}
    .i_part1 .state_sp{color:rgba(65,132,244,1);}
	.i_part1 .state_pp{.f-s(12);font-family:PingFangSC-Regular;font-weight:400;color:rgba(245,171,21,1);}
	.i_part1 .state_pq{.f-s(12);font-family:PingFangSC-Regular;font-weight:400;color:rgba(65,132,244,1);}
    .i_part2{.h(50);}
    .p_count{float:left;.l-h(50); .f-s(13); color:rgba(51,51,51,1);}
    .p_count .i_money{ .f-s(14);color:rgba(255,134,48,1); }
    .p_btns{float:right;.l-h(50)}
    .p_btns span{display:inline-block; .h(30); .w(56);text-align:center; .l-h(28); color:#999; border:1px solid #999;margin-left:0.2rem;border-radius:2px;font-size: 12px}
    .p_btns span:nth-child(1){margin-left: 0}
	.p_btns .acDo_btn_1{border-color:#4184F4; color:#4184F4;}
    .p_btns .acDo_btn_2{background:#4184F4;border-color:#4184F4;color:#fff;}
    .p_btns .acDo_btn_3{background:#f5f5f5;color:#999;border-color:#f5f5f5;}
	.add-order{position: fixed;bottom: 0;left: 0;right:0;/* .w(375); */width:100%;.h(46);.l-h(46);background: rgba(74,144,226,1);.f-s(16);font-family: PingFangSC-Regular;font-weight: 400;color: rgba(255,255,255,1);text-align: center;z-index:9}
    
    /* 追加订单费用 */
    .modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 20px;}
    .title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
   .list-wrap{padding: 18px 21px 6px 21px;}
   .list-wrap li{margin-bottom: 10px}
   .select-mark{display: inline-block;width:17px;height:17px;border-radius: 50%;margin-right: 7px;vertical-align: top;margin-top: 4px}
   .on{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
   .modal-text{display: inline-block;width: 243px;font-size:15px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);vertical-align: top;}
   .modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:5px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}
   /* .cost{margin-bottom: 10px;font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);}
    .cost-wrap{padding-left: 23px;padding-top: 20px}
    .cost-num{width:278px;height:40px;padding-left: 22px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(151,151,151,1);font-family:PingFangSC-Regular;font-size:13px;font-weight:400;color:rgba(153,153,153,1);}
    .un-boder{border: none;justify-content: space-between;}
    .modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}
    .submit-mt{margin-top: 110px} */
    
    /* 是否设置截止时间弹框 */
    .time-common{.w(277.5);.h(40);.l-h(40);margin:0 auto;border-radius:5px;text-align: center;.f-s(18);font-family:PingFangSC-Regular;font-weight:400;}
    .set-time{background:rgba(65,132,244,1);color:rgba(255,255,255,1);margin: 19px auto 20px auto}
    .no-time{background:rgba(255,255,255,1);border:1px solid rgba(207,207,207,1);color:rgba(153,153,153,1);}
	
	
	/* 派单选择业务员弹框 */
	.sale-wrap{padding:20px 25px 20px 22px;}
	.sale-wrap select{/* -webkit-appearance: none; */width: 100%;height: 40px;padding-left: 17px;margin-bottom: 14px;margin-top: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(151,151,151,1);}
	.name-title{font-size: 14px;font-family: PingFangSC-Regular;font-weight: 400;color: rgba(20,20,20,1);}
	.commission-wrap{width: 100%;height: 40px;margin-top: 10px;background: rgba(245,245,245,1);border-radius: 2px;border: 1px solid rgba(151,151,151,1)}
	.com-mb{margin-bottom: 14px}
	.commission-wrap input{width: 88%;height: 100%;padding-left: 17px;background: rgba(245,245,245,1);}
	.submit-sale{width:277.5px;height:40px;line-height: 40px;margin:0 auto;background:rgba(65,132,244,1);border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(255,255,255,1);text-align: center}

	/* 撤单理由弹框 */
	.textarea{width: 278px;height: 100px;padding: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(207,207,207,1);resize: none;outline: none;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(153,153,153,1);}
	.done{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.num{font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);margin-bottom: 12px}
	
	/* 搜索栏 */
	.fixed-wrap{position: -webkit-sticky;position: sticky;top: 0;left: 0;right: 0;width: 100%;}
	.search-wrap{width:100%;height:57.5px;display: flex;align-items: center;justify-content: center;background:rgba(255,255,255,1);border-bottom: 1px solid #E5E5E5;}
	.search-content{width:345px;height:37.5px;background:rgba(245,245,245,1);border-radius:3px;}
	.search-content input{height: 100%;width: 100%;box-sizing: border-box; padding-left: 37px;background:#f5f5f5 url("../../assets/images/order-manage/ic_search.png") no-repeat 9px center;background-size: 18px;}
    
    .p_btns .un-click{background:#999;border-color: #999;color: #fff;}

</style>    